import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Overlay from './Overlay';
import CertificateList from './CertificateList';
import { variants } from '../../../variants/variants';
import { useSelector } from 'react-redux';
import { selectCurrentUser, selectFcmToken } from '../../Auth/authSlice';
import GNXTLogo from '../../../assets/GatewayLogo/G_NXTLogo.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { selectIframeMessage } from '../webviewSlice';
import useDetectKeyboardOpen from 'use-detect-keyboard-open';

const MobileView = ({ URL, comingSoon, id, isSPOCRequest ,isArchivement }) => {
  const [loading, setLoading] = useState(true);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight); // ✅ track height
  const user = useSelector(selectCurrentUser);
  const fcm = useSelector(selectFcmToken);
  const navigate = useNavigate();
  const iframeMessage = useSelector(selectIframeMessage);
  const iframeRef = useRef();
  const { pathname } = useLocation();
  const isKeyboardOpen = useDetectKeyboardOpen();

  const isReimbursement = pathname.split('/')[4] === 'reimbursement';

  const urlQuery = `?header=${user?.details?.header}&travelData=${user?.details?.travelData?.travelToken}&userId=${user?.empId}&fcm=${
    fcm || 'abcd'
  }&id=${id}&isSpocRequest=${isSPOCRequest}`;

  // ✅ update window height on resize/orientation change
  useEffect(() => {
    const handleResize = () => setWindowHeight(window.innerHeight);

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      navigate('/home/announcement/gatewaybox');
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [navigate]);

  useEffect(() => {
    if (iframeMessage && iframeRef.current) {
      iframeRef.current.contentWindow.postMessage(
        iframeMessage,
        process.env.REACT_APP_REIMBURSEMENT_DOMAIN
      );
      console.log('message sent successfully');
    }
  }, [iframeMessage]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_REIMBURSEMENT_DOMAIN) return;

      if (event.data.type === 'backClicked') {
        navigate('/home/announcement/gatewaybox');
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [navigate]);

  return (
    <Grid
      container
      sx={{
        height: isReimbursement
          ? `${windowHeight}px` // ✅ always use actual viewport height
          : '100%',
        borderRadius: variants.boxRadius.MAIN,
        overflow: 'hidden',
        border: isReimbursement ? 0 : 1,
        borderColor: 'divider',
        position: 'relative',
      }}
    >
      {/* Show Certificate List for Achievements */}
      {isArchivement ? (
        <CertificateList />
      ) : (
        <>
          {/* Overlay for Coming Soon */}
          {comingSoon && (
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                backgroundColor: 'white',
                zIndex: 2,
              }}
            >
              <Overlay />
            </Box>
          )}

          {/* Loader */}
          {loading && (
            <Grid sx={{ margin: '0px auto' }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '70vh',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0.5)',
                  backdropFilter: 'blur(5px)',
                }}
              >
                <img src={GNXTLogo} style={{ height: 70, width: 150 }} alt="Logo" />
                <Typography sx={{ mt: 2 }}>Loading...</Typography>
              </Box>
            </Grid>
          )}

          {/* Iframe */}
         {URL && <iframe
            ref={iframeRef}
            src={URL.includes('expense') ? `${URL}/${urlQuery}` : URL}
            id="myIframe"
            height="100%"
            width="100%"
            style={{ border: 0 }}
            onLoad={() => setLoading(false)}
            title="External Content"
          />}
        </>
      )}
    </Grid>
  );
};

export default MobileView;
